<script setup lang="ts">
import Email from "../common/Email.vue";
import { DirectLink, Trainer, Participant, Project } from "../../types/PersologOnlineTypes";
import QuestionnaireLink from "../common/QuestionnaireLink.vue";
import ParticipantActivityTimeline from "./ParticipantActivityTimeline.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    project: {
        type: Object as () => Project,
        required: true,
    },
    participant: {
        type: Object as () => Participant,
        required: true,
    },
    trainer: {
        type: Object as () => Trainer,
        required: true,
    },
    directLink: {
        type: Object as () => DirectLink | null,
        default: null,
    },
});

const { t } = useI18n();

const persologBaseUrl = import.meta.env.VITE_APP_PERSOLOG_URL || "https://persolog.online";
const questionnairePath = import.meta.env.VITE_APP_QUESTIONNAIRE_FRONTEND_PATH || "/questionnaire";

const deletionDate = ref(new Date(props.participant.deletionDate || ""));

function buildUrl(hash: string) {
    return `${persologBaseUrl}${questionnairePath}/${hash}?lang=${props.project?.language}`;
}
</script>

<template>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-8">
            <div class="mb-2">
                <QuestionnaireLink
                    v-if="participant.status !== 'CREATED'"
                    :url="buildUrl(participant.questionnaire!)"
                />
            </div>
            <br />
            <div>
                <Email
                    v-if="!project.anonymous"
                    :recipient="participant"
                    :sender="trainer"
                    :project="project"
                    :direct-link="directLink"
                />
            </div>
            <br />

            <!-- Deletion date -->
            <div v-if="participant.deletionDate" class="input-container md:w-1/6 p-0 w-1/3">
                <label class="info-label" for="`participant_details-datepicker_deletion-date-${participant?.id ?? 0}`"
                    >{{ t("project-details.deletionDate.label") }}
                </label>
                <DatePicker
                    :id="`participant_details-datepicker_deletion-date-${participant?.id ?? 0}`"
                    v-model="deletionDate"
                    disabled
                    date-format="yy-mm-dd"
                />
            </div>
            <br />
            <ParticipantActivityTimeline :participant="participant" />
        </div>
    </div>
</template>

<style>
.input-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: left;
    .input-field {
        flex-direction: row !important;
    }
}

.info-label {
    font-size: 12px;
    color: #7e868d;
}
</style>
